import { useState, useEffect } from 'react';

// Widths must stay in sync with src/styles/breakpoints.css (--bp-split/--bp-ipad/--bp-ipad-lg).
export const BP_SPLIT = 580;
export const BP_IPAD = 834;
export const BP_IPAD_LG = 1024;

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handleChange = () => setMatches(mql.matches);
    handleChange();
    mql.addEventListener('change', handleChange);
    return () => mql.removeEventListener('change', handleChange);
  }, [query]);

  return matches;
}

// Phones and narrow iPad Split View — sidebar swaps for the bottom tab bar here.
export const useIsMobile = () => useMediaQuery(`(max-width: ${BP_SPLIT - 1}px)`);

// iPad+ widths where the sidebar stays persistent.
export const useIsTabletPersistentSidebar = () => useMediaQuery(`(min-width: ${BP_SPLIT}px)`);
